export default __webpack_public_path__ + "49cfe584740686f34e3992c3e1f23463.png";